export const homeStyle = {
  wrapper: {
    position: 'relative',
    background: 'var(--default-white)',
    borderRadius: '8px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'var(--box-shadow--2)',
    height: '100%',
    minHeight: 'calc(100vh - 128px)',

    '@media (max-width: 1199.98px)': {
      minHeight: 'calc(100vh - 152px)',
    },

    '@media (max-width: 639.98px)': {
      padding: '20px',
    },
  },

  imageWrapper: {
    display: 'flex',
    gap: '24px',
    marginBottom: '24px',

    '@media (max-width: 1023.98px)': {
      flexDirection: 'column',
      gap: '20px',
    },
  },

  textWrapper: {
    marginBottom: '24px',
  },

  title: {
    marginBottom: '8px',
  },

  data: {
    fontWeight: '400',
    color: 'var(--neutral-300)',
    marginBottom: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '@media (max-width: 1199.98px)': {
      // flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: '24px',
    },
  },

  time: {
    fontWeight: '400',
    color: 'var(--neutral-300)',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },

  alignWrapper: {
    fontWeight: '400',
    color: 'var(--neutral-300)',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',

    svg: {
      width: '16px',
      height: '16px',
    },
  },

  address: {
    fontWeight: '400',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: 'var(--neutral-300)',
    marginBottom: '4px',

    svg: {
      path: {
        fill: 'var(--neutral-300)',
      },
    },
  },

  iconWrapper: {
    display: 'flex',
    alignItems: 'center',

    svg: {
      path: {
        fill: 'var(--default-white)',
      },
    },
  },

  moneyIconWrapper: {
    display: 'flex',
    alignItems: 'center',

    svg: {
      path: {
        fill: 'var(--primary-500)',
      },
    },
  },
  disabledIcon: {
    svg: {
      path: {
        fill: 'var(--primary-200)',
      },
    },
  },

  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: '10px',
  },

  sectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '45%',
    justifyContent: 'space-between',

    '@media (max-width: 1199.98px)': {
      width: '50%',
    },

    '@media (max-width: 1023.98px)': {
      width: '100%',
    },
  },

  image: {
    width: '55%',
    height: '340px',
    overflow: 'hidden',

    // Для великих планшетів та малих ноутбуків
    '@media (max-width: 1199.98px)': {
      width: '50%',
    },

    // Для мобільних та планшетів (вертикальних)
    '@media (max-width: 1023.98px)': {
      width: '100%',
      height: 'auto',
      aspectRatio: '16 / 9',
    },

    '& img': {
      width: '100%',
      height: '100%',
      display: 'block',
      objectFit: 'cover',
    },
  },

  popularWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '8px',

    '@media (max-width: 374.98px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '4px',
    },
  },

  lotList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px',

    '@media (max-width: 1023.98px)': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },

    '@media (max-width: 959.98px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '12px',
    },

    '@media (max-width: 375px)': {
      gridTemplateColumns: '1fr',
      gap: '12px',
    },
  },

  progressWrap: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '175px',

    '@media (max-width: 1199.98px)': {
      marginBottom: '0px',
      marginTop: '0px',
    },

    '@media (max-width: 1023.98px)': {
      marginTop: '12px',
      marginBottom: '24px',
    },
  },

  progressValue: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
  },

  progressTargetAmount: {
    fontWeight: '700',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    // flexDirection: 'column',
  },

  progressTargetGoal: {
    color: 'var(--neutral-300)',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },

  modalLogin: {
    '.MuiPaper-root': {
      maxWidth: '770px',
      padding: '48px 200px',
      width: '100%',

      '@media (max-width: 1199.98px)': {
        padding: '40px 60px',
      },

      '@media (max-width: 639.98px)': {
        padding: '32px 16px',
      },
    },
  },

  modal: {
    '.MuiPaper-root': {
      maxWidth: '972px',
      padding: '48px 12px',
      width: '100%',

      '@media (maxWidth: 639.98px)': {
        padding: '32px 8px',
      },
    },
  },

  modalTickets: {
    '.MuiPaper-root': {
      position: 'relative',
      maxWidth: '1170px',
      width: '100%',
      maxHeight: 'calc(100% - 48px)',
      height: '100%',
      padding: '48px 38px 0 48px',
      scrollbarGutter: 'stable',
      margin: '0 15px',
      borderRadius: '8px 8px 0 0 ',

      '@media (max-width: 1199.98px)': {
        maxWidth: '100%',
        padding: '32px 20px 0 24px',
      },

      '@media (max-width: 639.98px)': {
        padding: '24px 12px 0 12px',
        margin: '0 8px',
      },
    },

    '&.MuiDialog-root': {
      height: 'calc(100% - 80px)',
    },
  },

  modalBid: {
    '.MuiPaper-root': {
      maxWidth: '972px',
      padding: '48px 200px',
      width: '100%',

      '@media (max-width: 1199.98px)': {
        padding: '48px 80px',
      },

      '@media (max-width: 639.98px)': {
        padding: '48px 20px',
      },
    },
  },

  description: {
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-line',
  },

  loader: {
    position: 'absolute',
    left: 'calc(50% - 25px)',
    top: '200px',
  },

  sponsorList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px',
    marginBottom: '12px',

    '@media (max-width: 1023.98px)': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },

    '@media (max-width: 959.98px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '12px',
    },

    '@media (max-width: 375px)': {
      gridTemplateColumns: '1fr',
    },
  },

  sponsor: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: 0,
    borderRadius: '8px',
    overflow: 'hidden',
    background: 'var(--default-white)',
    boxShadow: '0px 4px 16px 0px rgba(40, 103, 131, 0.06)',
  },

  sponsorImage: {
    width: '100%',
    aspectRatio: '4 / 3',
    overflow: 'hidden',

    '& img': {
      width: '100%',
      height: '100%',
      display: 'block',
      objectFit: 'cover',
    },
  },

  sponsorName: {
    padding: '12px',
    textAlign: 'center',
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  sponsorTitle: {
    marginBottom: '8px',
    textTransform: 'capitalize',
  }
};
